import { useTranslation } from 'react-i18next';

export default function AboutSection() {
  const { t } = useTranslation('common');

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl bg-gradient-to-br from-slate-900 via-slate-800 to-cyan-900">
              <div className="w-full h-[500px] flex items-center justify-center p-12">
                <img
                  src="https://static.readdy.ai/image/13ed06d0ea3cd7415a60a84f36bd9762/a73031cc809a317f27d0bbddc92453e1.png"
                  alt="BridgeOn Solutions Logo"
                  className="w-full h-full object-contain"
                />
              </div>
            </div>

            {/* Floating Badge */}
            <div className="absolute -bottom-6 -right-6 bg-gradient-to-br from-cyan-500 to-blue-600 text-white rounded-2xl p-6 shadow-xl">
              <div className="text-4xl font-bold">5+</div>
              <div className="text-sm">Years Experience</div>
            </div>
          </div>

          {/* Content */}
          <div className="space-y-6">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
              {t('about.title')}
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed">
              {t('about.description')}
            </p>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 pt-8">
              <div className="text-center">
                <div className="text-3xl font-bold text-cyan-600 mb-2">200+</div>
                <div className="text-sm text-gray-600">Projects</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-600 mb-2">150+</div>
                <div className="text-sm text-gray-600">Clients</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-purple-600 mb-2">98%</div>
                <div className="text-sm text-gray-600">Satisfaction</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}